import Config from 'Config';
import DashboardAppWorker from './dashboard-app-worker/DashboardAppWorker';

export const GROWTH_ENGINE_EVENT_CATEGORY = {
  mainNavigation: 'Growth Engine Main Navigation',
  trendingTopicsTab: 'Growth Engine Tab Trending Topics',
  contentOpportunitiesTab: 'Growth Engine Tab Content Opportunities',
  customContentStudioTab: 'Growth Engine Tab Custom Content Studio',
  onboardingStep1: 'Growth Engine Onboarding Step 1',
  onboardingStep2: 'Growth Engine Onboarding Step 2',
  onboardingStep3: 'Growth Engine Onboarding Step 3',
  onboardingStep4: 'Growth Engine Onboarding Step 4',
  onboardingUpgrade: 'Growth Engine Tab Onboarding Upgrade to Access',
} as const;

export const GROWTH_ENGINE_EVENT_LABEL = {
  exploreWithTwaia: 'Explore with Twaia',
  continueWithTwaia: 'Continue with Twaia',
  createCustomOpportunity: 'Create Custom Opportunity',
  discussWithTwaia: 'Discuss with Twaia',
} as const;

const PLATFORM_FIELDS_OBJECT: Record<string, string> = {
  standalone: 'SA',
  wix: 'Wix Main',
  aaas: '3AS',
};

type GrowthEngineEventCategory = (typeof GROWTH_ENGINE_EVENT_CATEGORY)[keyof typeof GROWTH_ENGINE_EVENT_CATEGORY];
type GrowthEngineEventLabel = (typeof GROWTH_ENGINE_EVENT_LABEL)[keyof typeof GROWTH_ENGINE_EVENT_LABEL];

export function trackGrowthEngineClick(category: GrowthEngineEventCategory, label?: GrowthEngineEventLabel) {
  DashboardAppWorker.trackEvent({
    category,
    action: 'onclick',
    label: label ?? '',
    value: 'Button',
    fieldsObject: PLATFORM_FIELDS_OBJECT[Config.appType] ?? Config.appType,
  });
}
